import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, ReplaySubject } from 'rxjs';
import { concatMap, take } from 'rxjs/operators';

import { EmployeeProfileService } from './employee-profile.service';
import { ApiCreds } from '../models';
import { tipFormDownloadUrl } from './constants';
import * as fileSaver from 'file-saver';

@Injectable({ providedIn: 'root' })
export class TipFormDownloadService {
  tipFormDownloadSubject = new ReplaySubject(1);
  tipFormDownloadData$ = this.tipFormDownloadSubject.asObservable();

  constructor(private employeeProfileService: EmployeeProfileService, private http: HttpClient) {}

  download(tipForm: string) {
    this.fetchTipFormDownload(tipForm).subscribe(response => {
      const fileName = `tipForm_${tipForm}.pdf`;

      const blob = new Blob([response], { type: 'application/pdf' });

      fileSaver.saveAs(blob, fileName);
    }),
      (error: Error) => console.log('Error downloading the file', error),
      () => console.log('File downloaded successfully');
  }

  private fetchTipFormDownload(tipForm: string): Observable<Blob> {
    //* 1. Collect Employee Api Credentials from Profile Service.
    return this.employeeProfileService.apiCreds$.pipe(
      take(1),
      //* 2. concatMap to allow inner Observable & fetch Data with apiCreds
      concatMap(apiCreds => this.fetchData(apiCreds, tipForm))
    );
  }

  /* Fetch Data from API using Employee API Credentials */
  private fetchData(apiCreds: ApiCreds, tipForm: string): Observable<Blob> {
    //* 1. Build URL string
    const url = `${tipFormDownloadUrl}/${apiCreds.bcl}/${apiCreds.id}/${tipForm}`;
    //* 2. Fetch URL string and create Observable with Data.
    return this.http.get(url, { responseType: 'blob' });
  }
}
